/*
 * Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
export var Container = {};
export var FormContainer = {};
export var FormSection = {};
export var FormField = {};
export var SectionHeader = {};
export var SectionBody = {};
export var SectionFooter = {};
export var SectionFooterPrimaryContent = {};
export var SectionFooterSecondaryContent = {};
export var Input = {};
export var Button = {};
export var PhotoPickerButton = {};
export var PhotoPlaceholder = {};
export var SignInButton = {};
export var SignInButtonIcon = {};
export var SignInButtonContent = {};
export var Strike = {};
export var StrikeContent = {};
export var ActionRow = {};
export var FormRow = {};
export var A = {};
export var Hint = {};
export var Radio = {};
export var Label = {};
export var InputLabel = {};
export var AmazonSignInButton = {};
export var FacebookSignInButton = {};
export var GoogleSignInButton = {};
export var OAuthSignInButton = {};
export var Toast = {};
export var NavBar = {};
export var NavRight = {};
export var Nav = {};
export var NavItem = {};
export var NavButton = {};
var AmplifyTheme = {
    container: Container,
    formContainer: FormContainer,
    formSection: FormSection,
    formField: FormField,
    sectionHeader: SectionHeader,
    sectionBody: SectionBody,
    sectionFooter: SectionFooter,
    sectionFooterPrimaryContent: SectionFooterPrimaryContent,
    sectionFooterSecondaryContent: SectionFooterSecondaryContent,
    input: Input,
    button: Button,
    photoPickerButton: PhotoPickerButton,
    photoPlaceholder: PhotoPlaceholder,
    signInButton: SignInButton,
    signInButtonIcon: SignInButtonIcon,
    signInButtonContent: SignInButtonContent,
    amazonSignInButton: AmazonSignInButton,
    facebookSignInButton: FacebookSignInButton,
    googleSignInButton: GoogleSignInButton,
    oAuthSignInButton: OAuthSignInButton,
    formRow: FormRow,
    strike: Strike,
    strikeContent: StrikeContent,
    actionRow: ActionRow,
    a: A,
    hint: Hint,
    radio: Radio,
    label: Label,
    inputLabel: InputLabel,
    toast: Toast,
    navBar: NavBar,
    nav: Nav,
    navRight: NavRight,
    navItem: NavItem,
    navButton: NavButton,
};
export default AmplifyTheme;
//# sourceMappingURL=Amplify-UI-Theme.js.map